var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.383 8h1.06C20.304 8 21 8.696 21 9.556v9.889c0 .859-.696 1.555-1.556 1.555H8.556C7.696 21 7 20.304 7 19.444V18",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 18h11.313c.669 0 1.293-.334 1.664-.891l.734-1.102a4 4 0 00.672-2.22V6a2 2 0 00-2-2h-10a2 2 0 00-2 2v7.056c0 .62-.145 1.233-.422 1.789l-.854 1.708A1 1 0 004 18z",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.655 13.374h2.344M13.826 13.374V9.001l-1.276 1.155M8.001 9.84c.14-.48.565-.839 1.09-.839.637 0 1.154.516 1.154 1.154 0 .57-.463 1.033-1.033 1.033.57 0 1.033.462 1.033 1.032 0 .637-.516 1.154-1.154 1.154-.525 0-.95-.358-1.09-.84M8.38 3v2M14.38 3v2",
    stroke: "#F05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCalendar;